module.exports = __webpack_public_path__ + "img/no-voucher.213c3a0e.png";